<template>
  <base-container
    title="Quick Links"
    :withGradient="links.length > 1"
    header-central
    no-padding
    view-link="/profile/quicklinks"
    view-text="Manage links"
    :class="cssLabel"
  >
    <base-scroll-list>
      <ol v-if="links.length > 0" role="list">
        <li v-for="(link, index) in links" :key="index" role="listitem">
          <div class="preview-card row" role="article" tabindex="0">
            <div class="content col-xs-12 flex space-between items-center">
              <a :href="link.url" target="_blank" class="link--quick">
                <icon name="link" width="16" height="16" :fill="false" />
                <span>{{ link.name }}</span>
              </a>
              <base-tooltip
                :text="
                  isPriority(link) ? 'Unpin from Toolbar' : 'Pin to Toolbar'
                "
                v-if="canShowStar(link)"
              >
                <tr-action
                  icon="pin"
                  label="Pin"
                  @click="onClickStar(link)"
                  :active="isPriority(link)"
                  highlight-stroke
                ></tr-action>
              </base-tooltip>
            </div>
          </div>
        </li>
      </ol>
      <p v-else role="link">There are no links</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
/**
 * # Dashboard link widget
 * ---
 * A widget to display a users favourite links, with action to prioritize
 */
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

import TrAction from "@/components/TableRowAction";

export default {
  name: "LinksWidget",
  components: {
    BaseContainer,
    BaseScrollList,
    TrAction,
  },

  data() {
    return {
      postLimit: 1,
      links: [],
    };
  },

  computed: {
    cssLabel() {
      if (this.cssClass === 4) {
        return "c-container--sm";
      }
      if (this.cssClass === 6) {
        return "c-container--md";
      }
      return "c-container--lg";
    },
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
    cssClass: {
      type: [Number, String],
    },
  },

  /**
   * When mounted we need to get the news items.  We also need to read the users interest group id's
   * TODO: Should these be put in state or just read from the user object
   */
  async mounted() {
    await this.$store.dispatch("widgets/links/setLimit", this.limit);
    await this.$store.dispatch("widgets/links/getLargestLimit");
    this.$store.dispatch("widgets/links/getUserLinks").then((resp) => {
      this.links = resp.slice(0, this.limit);
    });
  },

  methods: {
    async onClickStar(el) {
      // dispatch to make it a link, mark it as favourite now
      el.priority = el.priority === 1 ? 0 : 1;
      await this.$store.dispatch("widgets/links/setFavourite", el);
    },
    canShowStar(link) {
      if (link.priority || link.priority === 1) {
        return true;
      }

      const linkCount = this.links.filter(
        (link) => link.priority || link.priority === 1
      );
      return linkCount.length < 3;
    },
    isPriority(el) {
      return el.priority;
    },
    handleLinkClick(link) {
      const a = document.createElement("a");
      a.id = "generatedLink";
      a.href = link.url || link.link;
      a.target =
        a.href.includes("http") && !a.href.includes(window.location.host)
          ? "_blank"
          : "_self"; // Do we want to open in a new window?
      a.rel = "noopener nofollow external";
      a.click();
    },
  },

  watch: {
    limit: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        this.postLimit = newValue;
        this.$store
          .dispatch("widgets/links/setLimit", this.postLimit)
          .then(() => {
            this.$store.dispatch("widgets/links/clearCache").then(() => {
              this.$store
                .dispatch("widgets/links/getUserLinks")
                .then((resp) => {
                  this.links = resp.slice(0, this.limit);
                });
            });
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
ol {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
}
li {
  margin: 5px;
  width: 100%;

  border-radius: 4px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.11);
  padding: 1rem;
}
.link--quick {
  display: flex;
  align-content: center;
  font-size: 1rem;
  text-decoration: none;
  color: $colour-nhs-dark-grey;
  width: calc(100% - 2em);

  span {
    margin-left: 10px;
    width: 250px;
    max-width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

ol > * {
  transition: all ease-in-out 0.1s;
}

ol:hover > * {
  opacity: 0.6;
}

ol:hover > *:hover {
  opacity: 1;
}

.c-container--md {
  @media (min-width: 768px) {
    li {
      width: calc(50% - 10px);
    }
  }
}

.c-container--lg {
  @media (min-width: 768px) {
    li {
      width: calc(33.3% - 10px);
    }
  }
}
</style>
